<template>
  <div class="w-full">
    <div class="relative">
      <img
        src="@/assets/images/line/Vector 7.png"
        alt="lineimg"
        class="m-auto mob-hidden"
      />
      <!-- <div class="absolute bg-design4 mob-hidden">
        <img
          src="../../../assets/images/bg-des/bgd4.svg"
          alt="bg-polygon"
          class=""
        />
      </div>
      <div class="absolute bg-design5 mob-hidden">
        <img
          src="../../../assets/images/Ellipse 12.svg"
          alt="bg-polygon"
          class="h-full"
        />
      </div> -->
      <div
        class="lg:flex md:flex lg:gap-10 md:gap-10 items-center custflexdirection"
      >
        <div class="lg:w-1/2 md:w-1/2 w-full">
          <img
            src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/CG/JoinUs/Benefits-of-joining-our-community.jpeg"
            alt="aboutus"
            class="m-auto custborderradius"
          />
        </div>
        <div class="lg:w-1/2 md:w-1/2 w-full">
          <div class="lg:mt-16 md:mt-16 mt-0">
            <p class="title sm-fsize16 md:font-normal lg:font-normal font-bold">
              Benefits of joining our community
            </p>

            <ul class="list-disc lg:pt-10 md:pt-10 pt-2 pl-5">
              <li class="subtitle lh32px sm-fsize14 mb-2">
                Get access to our exclusive social space to connect with a peer
                community of active and experienced caregivers.
              </li>
              <li class="subtitle lh32px sm-fsize14 mb-2">
                Share your story, learn and grow with the support of the
                community that understands you.
              </li>
              <li class="subtitle lh32px sm-fsize14 mb-2">
                Get access to verified and trained resources to ease your
                caregiving journey.
              </li>

              <li class="subtitle lh32px sm-fsize14 mb-2">
                Empower yourself through learning programs and upskilling
                workshops.
              </li>
              <li class="subtitle lh32px sm-fsize14 mb-2">
                Emotional Mastery/Resilience building through counselling,
                coaching and support group sessions.
              </li>
              <li class="subtitle lh32px sm-fsize14 mb-2">
                Access to curated healthcare products and services from reliable
                partners.
              </li>
              <li class="subtitle lh32px sm-fsize14 mb-2">
                Access to financial, legal and insurance advisory for planning
                your caregiving needs.
              </li>
              <li class="subtitle lh32px sm-fsize14 mb-2">
                Access to learning tools like handbooks.
              </li>
              <li class="subtitle lh32px sm-fsize14 mb-2">
                An opportunity to volunteer and be a changemaker.
              </li>
            </ul>
          </div>
          <!-- <div class="lg:pt-10 md:pt-10 pt-4">
            <base-button
              outline
              type="primary"
              class="
                md:px-10
                lg:px-10
                px-6
                md:py-3
                lg:py-3
                py-1
                fs16700
                border-2
              "
              @click="handleClick('about-us')"
              >Read More</base-button
            >
          </div> -->
        </div>
      </div>
    </div>
    <div class="relative">
      <img
        src="@/assets/images/line/Vector 9.png"
        alt="lineimg"
        class="m-auto mob-hidden"
      />
      <div class="lg:flex md:flex justify-center">
        <div
          class="borderprimary bg-white lg:p-4 lg:absolute md:absolute top-32 md:p-4 lg:mt-0 md:mt-0 mt-5 rounded-2xl lg:w-auto md:w-auto w-3/5 m-auto"
        >
          <div class="bgcceff2 rounded-2xl">
            <div class="lg:flex md:flex items-center lg:p-6 md:p-6 p-4">
              <p
                class="font-semibold text-black text-center fsize20 sm-fsize14"
              >
                Join our community
              </p>
              <div
                class="lg:pl-14 md:pl-14 lg:pt-0 md:pt-0 pt-4 items-center flex lg:justify-start md:justify-start justify-center"
              >
                <!-- <a
                class="hover:text-white"
                target="_blank"
                href="https://tinyurl.com/Join-Our-CS-Community"
              > -->
                <base-button
                  type="primary"
                  class="py-2 px-8 lg:text-base md:text-base sm-fsize14 font-bold border-2 lg:w-auto md:w-auto w-full"
                  @click="handleClick('register')"
                  >Sign up</base-button
                >
                <!-- </a
              > -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState("auth", ["user"]),
  },
  methods: {
    handleClick(name) {
      // this.$router.push({ name: name });
      if (Object.keys(this.user).length === 0) {
        this.$router.push({ name: name });
      } else {
        this.$swal.fire({
          title: "Registered",
          text: "You're already a registered member",
          icon: "info",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
      }
    },
  },
};
</script>
<style>
.temp-520-auto {
  height: 520px;
}
</style>
